import React, { useEffect, useState } from 'react'
import { Badge, Button, Card, Col, Container, Image, Row, Table } from 'react-bootstrap'

import PageTitle from '../../layouts/PageTitle'

// import "./style.css"
import DeleteAccountModal from './DeleteAccountModal';
import { getAllUserProfileList } from '../../../services/userApiService/userService';

const DeleteUserAccount = () => {
  const [userData, setUserData] = useState({});
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const id = localStorage.getItem('id');
  const userCategoryMain = localStorage.getItem('user_category_main');
  const [userProfileImage, setUserProfileImage] = useState(null);
  const [profileImage, setProfileImage] = useState(
    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_1280.png"
  );

  const fetchUserData = async () => {
    try {
      const response = await getAllUserProfileList(userCategoryMain, id);
      setUserData(response?.data?.data);

      if (response?.data?.data?.user_category_main == 1) {
        const documents = response?.data?.data?.indivisual_docs || [];

        // console.log("documents",documents);

        const getDocumentPath = (type) => {
          const doc = documents.find(d => d.doc_name === type);
          return doc ? doc.doc_file : "";
        };

        setUserProfileImage(getDocumentPath("profile_image").replace(/\\\//g, '/'));
      }

    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    fetchUserData();
  }, [userCategoryMain, id]);
  const entity = userData?.indivisual || userData?.organization || {};
  const personalDetails = {
    "Full Name": userData?.first_name || 'NA',
    "Gender": entity.gender || 'NA',
    "Email ID": userData?.email || 'NA',
    "Mobile Number": entity.mobile || 'NA',
    "Identification": entity.identity_type || 'NA', // static
    "Identification Document": entity.identity_type || 'NA', // static
    "Landmark": entity.landmark || 'NA',
    "City": entity.city_name || 'NA',
    "Pincode": entity.pincode || 'NA',
    "Country": entity.country_name || 'NA',
    "State": entity.state_name || 'NA',
    "DOB": entity.dob || 'NA',
    "Full Address": entity.address || 'NA',
  };
  // Utility to chunk array into groups of 3
  const chunkArray = (arr, size) => {
    const result = [];
    for (let i = 0; i < arr.length; i += size) {
      result.push(arr.slice(i, i + size));
    }
    return result;
  };
  const detailEntries = Object.entries(personalDetails); // [[key, value], [key, value], ...]
  const chunkedRows = chunkArray(detailEntries, 3);
  return (

    <>
      <PageTitle
        activeMenu="Delete Account"
        motherMenu="Account Management"
      />
      <section>
        <Card className="px-5 py-4">
          <div className="mb-2">
            <h3>Delete Account</h3>
          </div>
          <Card className="p-4 deletaccountBoxshadow">
            <Card.Body>
              <h4 className="text-center mb-4 fw-bold">Personal Details</h4>

              <Row className="align-items-center mb-4">
                <Col md="auto">
                  {/* <Image
                    src="https://images.ctfassets.net/h6goo9gw1hh6/2sNZtFAWOdP1lmQ33VwRN3/24e953b920a9cd0ff2e1d587742a2472/1-intro-photo-final.jpg?w=1200&h=992&fl=progressive&q=70&fm=jpg" // Replace with actual image
                    width={80}
                    height={80}
                    className="account_profile_img"
                  /> */}
                  {userProfileImage
                    ? <img
                      src={userProfileImage}
                      alt="Profile"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                      onError={(e) => {
                        e.target.onerror = null; // prevent infinite loop
                        e.target.src = profileImage; // fallback image path
                      }}
                    />
                    :
                    <img
                      src={(userData?.indivisual || userData?.organization)?.[9]?.doc_file || profileImage}
                      alt="Profile"
                      style={{
                        width: "80px",
                        height: "80px",
                        objectFit: "cover",
                        borderRadius: "50%",
                      }}
                    />
                  }
                </Col>
                <Col>
                  <h5 className="mb-1">{userData?.first_name}</h5>
                  <div>{userData?.email}</div>
                </Col>
                <Col className="d-flex justify-content-end">
                  <div className="account_badge" text="dark">
                    Atom ID: <span >{userData?.atom_id}</span>
                  </div>
                </Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Table borderless size="sm">
                    <tbody>
                      {chunkedRows.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                          {row.map(([label, value], colIndex) => {
                            // Mapping for label "Identification Document"
                            let displayValue = value;

                            if (label === "Identification") {
                              // Convert keys to human-readable names
                              const documentNameMap = {
                                aadhaar: "Aadhaar",
                                pan_card: "PAN Card",
                                driving_license: "Driving License",
                              };

                              // If it's a URL, show image; else show readable name
                              const isUrl = typeof value === "string" && value.startsWith("http");

                              displayValue = isUrl ? (
                                <a href={value} target="_blank" rel="noopener noreferrer">
                                  <img
                                    src={value}
                                    alt="Document"
                                    style={{ maxWidth: "100px", maxHeight: "100px" }}
                                  />
                                </a>
                              ) : (
                                documentNameMap[value] || value
                              );
                            }

                            return (
                              <td key={colIndex} style={{ width: "33.33%" }}>
                                <h5 style={{ color: "#9CA3AF" }}>{label}</h5>
                                <div>{displayValue}</div>
                              </td>
                            );
                          })}
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>

            </Card.Body>
          </Card>
          <Card className="p-4 deletaccountBoxshadow">
            <Card.Body>
              <h5 className="fw-bold">Delete Account</h5>
              <p className="fw-semibold">Are you sure you want to delete your account?</p>
              <p className="text-muted">
                Once you delete your account, all your data will be gone forever.
              </p>

              <p style={{ color: "red", fontWeight: 600 }}>Note :- You will lose:</p>
              <ul style={{ paddingLeft: "1.5rem" }}>
                <li>All your bookings and history</li>
                <li>Saved venues and preferences</li>
                <li>Payment records and receipts</li>
                <li>Your profile and login access</li>
              </ul>

              <div className="mt-4">
                <Button className="gradient-btn w-100" onClick={handleShow}>Delete Account</Button>
              </div>
            </Card.Body>
          </Card>
        </Card>
      </section>


      <DeleteAccountModal

        show={show}
        handleClose={handleClose}
      // handleDelete={handleDeleteAccount}
      />




    </>
  )
}

export default DeleteUserAccount